import { Controller } from "@hotwired/stimulus"
import noUiSlider from "nouislider"
import debounce from "debounce"

export default class extends Controller {
  static targets = ["slider", "currentMin", "currentMax", "display"]

  static buildTimePoints(maxIndex) {
    const arr = []
    let t = new Date("1970-01-01T08:00:00")
    for (let i = 0; i <= maxIndex; i++) {
      arr.push(t.toTimeString().slice(0, 5))
      t = new Date(t.getTime() + 15 * 60 * 1000)
    }
    return arr
  }

  initialize() {
    this.debouncedUpdate = debounce(this.#handleUpdate.bind(this), 300)
  }

  connect() {
    this.#syncDisplay()
    const maxIdx = this.#timeToIndex(this.currentMaxTarget.value)
    const paddingSize = 4
    this.timePoints = this.constructor.buildTimePoints(maxIdx + paddingSize)
    const minIdx = Math.min(this.#timeToIndex(this.currentMinTarget.value), maxIdx)

    this.slider = noUiSlider.create(this.sliderTarget, {
      range: { min: 0, max: maxIdx + paddingSize },
      start: [minIdx, maxIdx],
      padding: [paddingSize, paddingSize],
      step: 1,
      connect: [false, true, false],
      tooltips: false,
      margin: 1,
    })

    this.slider.on("change", this.debouncedUpdate)
  }

  disconnect() {
    this.slider?.destroy()
  }

  #handleUpdate(_value, handle, unencoded) {
    const targets = [this.currentMinTarget, this.currentMaxTarget]
    const target = targets[handle]
    if (
      !target ||
      unencoded[handle] < 0 ||
      unencoded[handle] >= this.timePoints.length
    )
      return

    target.value = this.timePoints[unencoded[handle]]
    this.#syncDisplay()
    this.dispatch("change", {
      detail: {
        startTime: this.currentMinTarget.value,
        endTime: this.currentMaxTarget.value,
      },
      prefix: false,
      bubbles: true,
    })
  }

  #timeToIndex(timeStr) {
    if (!timeStr) return 0
    const [hour, min] = timeStr.split(":").map(Number)
    return (hour - 8) * 4 + min / 15
  }

  #syncDisplay() {
    this.displayTarget.textContent = `${this.currentMinTarget.value} - ${this.currentMaxTarget.value}`
  }
}
